// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { IBillsTableHeadersProps } from '../types';
import { BILLS_HEADER_CELL_STYLES, BILLS_TABLE_HEADER_STYLES } from '../styles';
import Heading from '../../../../../../../generic-components/Heading';

export const BillsTableHeader = ({ columns }: IBillsTableHeadersProps) => {
  const { t } = useTranslation();
  const headerCells = columns.map((column) => (
    <th
      id={`th_${column.key}`}
      key={column.key}
      className={BILLS_TABLE_HEADER_STYLES.TableTH}
    >
      <div className={BILLS_HEADER_CELL_STYLES[column.key]}>
        <Heading title={t(column.title)} className='' testId={`BillsHub__table-header-column-${column.key}`} />
      </div>
    </th>
  ));
  return (
    <thead className={BILLS_TABLE_HEADER_STYLES.TableTHead}>
      <tr>
        {headerCells}
      </tr>
    </thead>
  );
};
